import React, { useState } from "react";

import { useHistory } from "react-router-dom";

import DevRecoveryPassword from "../../../../../../presentation/pages/auth/developer/recovery-password";

import Authentication from "../../../../../../infra/cognito/authentication";
import { t } from "../../../../../../presentation/adapters/translate/translate";

const MakeDevRecoveryPassword: React.FC = () => {
  const recoveryEmail = localStorage.getItem("recoveryEmail");

  const [isVisible, setIsVisible] = useState<boolean>(false);

  const history = useHistory();

  const [errorMessage, setErrorMessage] = useState<string | null>("");

  const handleSubmit = async (values: any): Promise<void> => {
    if (values["new-password"] !== values["confirm-password"]) {
      setErrorMessage("As senhas não coincidem");
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      return;
    }

    try {
      await Authentication.recoveryPassword(
        recoveryEmail as string,
        values?.code,
        values["new-password"]
      );
      setIsVisible(true);
    } catch (error: any) {
      setErrorMessage(t(error.code, error.message));
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
    }
  };

  const handleConfirm = (): void => {
    setIsVisible(false);
    history.push("/");
  };

  const dataForm = [
    {
      items: [
        {
          component: "Input",
          name: "code",
          title: "Código",
          label: "Código",
          placeholder: "Código enviado por e-mail",
          validations: "inputRequired",
          autoComplete: "off",
        },
        {
          component: "InputPassword",
          type: "password",
          name: "new-password",
          title: "Nova Senha",
          label: "Nova Senha",
          placeholder: "Nova Senha",
          validations: "inputRequired",
          autoComplete: "off",
        },
        {
          component: "InputPassword",
          type: "password",
          name: "confirm-password",
          title: "Confirmar Senha",
          label: "Confirmar Senha",
          placeholder: "Confirmar Senha",
          validations: "inputRequired",
          autoComplete: "off",
        },
        {
          name: "button",
          component: "Button",
          title: "Alterar senha",
          submittingText: "Alterando...",
        },
      ],
    },
  ];

  const props = {
    onSubmit: handleSubmit,
    dataForm,
    errorMessage,
    isVisible,
    handleConfirm,
  };

  return <DevRecoveryPassword {...props} />;
};

export default MakeDevRecoveryPassword;
